var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "feature-images-section-wrapper" }, [
    _c(
      "div",
      {
        staticClass: "feature-images-container",
        class: { "single-column": _vm.getStaticScenes.length === 1 },
        style: !_vm.isExpanded ? "max-height:640px" : ""
      },
      _vm._l(_vm.getStaticScenes, function(roomScene, index) {
        return _c(
          "div",
          { key: roomScene, staticClass: "feature-image-wrapper" },
          [
            _c("wf-load-image", {
              attrs: {
                "wrapper-class": "feature-image-wrapper",
                "image-class": "pc-feature-images",
                src: roomScene,
                alt: "feature-image"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "descriptor-container" }, [
              _c("div", { staticClass: "descriptor-border-box" }, [
                _c("div", { staticClass: "descriptor-content-container" }, [
                  _c("span", { staticClass: "descriptor-text" }, [
                    _vm._v("STYLE:")
                  ]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.sellingStyleNumber) +
                      "\n                    "
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "descriptor-content-container" }, [
                  _c("span", { staticClass: "descriptor-text" }, [
                    _vm._v("COLOR:")
                  ]),
                  _vm._v(" "),
                  _c(
                    "a",
                    {
                      staticClass: "descriptor-link",
                      on: {
                        click: function($event) {
                          return _vm.getStaticColors(
                            _vm.parsedColorNumbers,
                            index
                          )
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                            " +
                          _vm._s(_vm.getColorDescription(roomScene)) +
                          "\n                        "
                      )
                    ]
                  )
                ])
              ])
            ])
          ],
          1
        )
      }),
      0
    ),
    _vm._v(" "),
    _vm.showMoreFeatureImages
      ? _c(
          "div",
          { staticClass: "more-feature-images-container text-center" },
          [
            _c(
              "a",
              {
                staticClass: "btn btn-white border-dark",
                attrs: { target: "_self" },
                on: { click: _vm.toggleExpanded }
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.isExpanded ? "VIEW LESS" : "VIEW MORE") +
                    "\n        "
                )
              ]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }